export default __webpack_public_path__ + "static/media/microweber.0e200ca7.svg";